/**
 * Distribution Tabs and Store Picker Modal
 * Handles the tab switching functionality and store picker modal
 */
class DistributionTabs {
  constructor(container) {
    this.container = container;
    this.tabButtons = this.container.querySelectorAll(".tab-button");
    this.tabContents = this.container.querySelectorAll(".tab-content");

    // 特惠配送相关状态
    this.isSpecialDeliverySelected = false;
    this.isNormalDeliverySelected = false;
    this.isPostalCodeValid = false;
    this.currentSpecialDelivery = null;
    this.currentNormalDelivery = null;

    this.init();
  }

  init() {
    this.setupTabEvents();
    this.setupSpecialDeliveryEvents();
    this.setupNormalDeliveryEvents();
  }

  setupTabEvents() {
    this.tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabType = button.getAttribute("data-tab");

        // Deactivate all tabs and contents
        this.tabButtons.forEach((btn) => btn.classList.remove("active"));
        this.tabContents.forEach((content) =>
          content.classList.remove("active")
        );

        // Activate current tab and content
        button.classList.add("active");
        this.container
          .querySelector(`.tab-content[data-content="${tabType}"]`)
          .classList.add("active");

        // 检查选择的配送方式
        this.isSpecialDeliverySelected = tabType === "special";
        this.isNormalDeliverySelected = tabType === "time";

        // 触发配送方式变化事件
        document.dispatchEvent(
          new CustomEvent("delivery-method:change", {
            detail: {
              method: tabType,
            },
          })
        );

        // 触发特惠配送状态变化事件
        this.dispatchSpecialDeliveryStateChange();

        // 触发普通配送状态变化事件
        this.dispatchNormalDeliveryStateChange();
      });
    });
  }

  /**
   * 设置特惠配送相关事件监听器 - 已禁用
   */
  setupSpecialDeliveryEvents() {
    /* 已注释特惠配送相关事件监听
    // 监听特惠配送更新事件
    document.addEventListener('special-delivery:updated', (event) => {
      this.currentSpecialDelivery = event.detail.specialDelivery;
      this.dispatchSpecialDeliveryStateChange();
    });

    // 监听邮编验证结果事件
    document.addEventListener('postal-code:validated', (event) => {
      this.isPostalCodeValid = event.detail.isValid;
      this.dispatchSpecialDeliveryStateChange();
    });
    */
  }

  /**
   * 设置普通配送相关事件监听器 - 已禁用
   */
  setupNormalDeliveryEvents() {
    /* 已注释普通配送相关事件监听
    // 监听普通配送更新事件
    document.addEventListener('normal-delivery:updated', (event) => {
      this.currentNormalDelivery = event.detail.normalDelivery;
      this.dispatchNormalDeliveryStateChange();
    });
    */
  }

  /**
   * 更新特惠配送显示
   */
  updateSpecialDeliveryDisplay() {
    if (!this.currentSpecialDelivery) return;

    // 查找特惠配送tab内容区域
    const specialDeliveryContent = this.container.querySelector(
      '.tab-content[data-content="special"]'
    );
    if (!specialDeliveryContent) return;

    // 更新价格显示
    const priceElement = specialDeliveryContent.querySelector(
      ".special-delivery-price"
    );
    if (priceElement && this.currentSpecialDelivery.price) {
      priceElement.textContent = `￥${this.currentSpecialDelivery.price}`;
    }

    // 显示特惠配送选项
    specialDeliveryContent.classList.add("has-special-delivery");
  }

  /**
   * 更新普通配送显示
   */
  updateNormalDeliveryDisplay() {
    if (!this.currentNormalDelivery) return;

    // 查找普通配送tab内容区域
    const normalDeliveryContent = this.container.querySelector(
      '.tab-content[data-content="time"]'
    );
    if (!normalDeliveryContent) return;

    // 更新价格显示
    const priceElement = normalDeliveryContent.querySelector(
      ".normal-delivery-price"
    );
    if (priceElement && this.currentNormalDelivery.price) {
      priceElement.textContent = `￥${this.currentNormalDelivery.price}`;
    }

    // 显示普通配送选项
    normalDeliveryContent.classList.add("has-normal-delivery");
  }

  /**
   * 触发特惠配送状态变化事件 - 已禁用
   */
  dispatchSpecialDeliveryStateChange() {
    /* 已注释特惠配送状态变化事件
    const canAddSpecialDelivery = this.isSpecialDeliverySelected && 
                                 this.isPostalCodeValid && 
                                 !!this.currentSpecialDelivery;

    // 获取正确的特惠配送变体ID
    const specialDeliveryVariantId = this.getSpecialDeliveryVariantId();
    
    // 构建特惠配送信息，确保包含正确的变体ID
    const specialDeliveryInfo = canAddSpecialDelivery ? {
      ...this.currentSpecialDelivery,
      variant: specialDeliveryVariantId
    } : null;

    // 发送特惠配送状态变化事件
    document.dispatchEvent(new CustomEvent('special-delivery:state-changed', {
      detail: {
        isSpecialDeliverySelected: this.isSpecialDeliverySelected,
        isPostalCodeValid: this.isPostalCodeValid,
        canAddSpecialDelivery: canAddSpecialDelivery,
        specialDelivery: specialDeliveryInfo
      }
    }));
    
    // 发送产品选项面板专用的特惠配送更新事件
    document.dispatchEvent(new CustomEvent('special-delivery:options-panel-update', {
      detail: {
        isPostalCodeValid: this.isPostalCodeValid,
        canAddSpecialDelivery: canAddSpecialDelivery,
        specialDelivery: specialDeliveryInfo,
        variantId: this.getCurrentVariantId()
      }
    }));
    */
  }

  /**
   * 触发普通配送状态变化事件 - 已禁用
   */
  dispatchNormalDeliveryStateChange() {
    /* 已注释普通配送状态变化事件
    const canAddNormalDelivery = this.isNormalDeliverySelected && 
                                !!this.currentNormalDelivery;

    // 获取正确的普通配送变体ID
    const normalDeliveryVariantId = this.getNormalDeliveryVariantId();
    
    // 构建普通配送信息，确保包含正确的变体ID
    const normalDeliveryInfo = canAddNormalDelivery ? {
      ...this.currentNormalDelivery,
      variant: normalDeliveryVariantId
    } : null;

    // 发送普通配送状态变化事件
    document.dispatchEvent(new CustomEvent('normal-delivery:state-changed', {
      detail: {
        isNormalDeliverySelected: this.isNormalDeliverySelected,
        canAddNormalDelivery: canAddNormalDelivery,
        normalDelivery: normalDeliveryInfo
      }
    }));
    
    // 发送产品选项面板专用的普通配送更新事件
    document.dispatchEvent(new CustomEvent('normal-delivery:options-panel-update', {
      detail: {
        canAddNormalDelivery: canAddNormalDelivery,
        normalDelivery: normalDeliveryInfo,
        variantId: this.getCurrentVariantId()
      }
    }));
    */
  }

  /**
   * 获取特惠配送变体ID（如果条件满足）
   * @returns {string|null}
   */
  getSpecialDeliveryVariantId() {
    if (window.variantMetafieldsHandler) {
      const variantId =
        window.variantMetafieldsHandler.getSpecialDeliveryVariantId();
      return variantId;
    }
  }

  /**
   * 获取普通配送变体ID（如果条件满足）
   * @returns {string|null}
   */
  getNormalDeliveryVariantId() {
    if (window.variantMetafieldsHandler) {
      const variantId =
        window.variantMetafieldsHandler.getNormalDeliveryVariantId();
      return variantId;
    }
  }

  /**
   * 获取当前产品变体ID
   * @returns {string|null}
   */
  getCurrentVariantId() {
    if (
      window.variantMetafieldsHandler &&
      window.variantMetafieldsHandler.currentVariant
    ) {
      return window.variantMetafieldsHandler.currentVariant.id;
    }
    return null;
  }

  /**
   * 检查是否可以添加特惠配送
   * @returns {boolean}
   */
  canAddSpecialDelivery() {
    return (
      this.isSpecialDeliverySelected &&
      this.isPostalCodeValid &&
      this.currentSpecialDelivery !== null
    );
  }

  /**
   * 检查是否可以添加普通配送
   * @returns {boolean}
   */
  canAddNormalDelivery() {
    return this.isNormalDeliverySelected && this.currentNormalDelivery !== null;
  }
}

/**
 * Postal Code Validator
 * Validates German postal codes against a predefined list
 */
class PostalCodeValidator {
  constructor(inputElement, resultElement) {
    this.inputElement = inputElement;
    this.resultElement = resultElement;
    this.init();
  }

  init() {
    this.setupEvents();
  }

  setupEvents() {
    const form = this.inputElement.closest("form");
    let debounceTimeout;
    // 只阻止旧配送卡片的点击切换，不阻止按钮默认触发表单提交。
    form.addEventListener("click", (event) => event.stopPropagation());
    this.inputElement.addEventListener("input", (e) => {
      clearTimeout(debounceTimeout);

      if (e.target.value.trim().length < 5) {
        this.validatePostalCode("");
        return;
      }

      // 保留 500ms 防抖；section 被替换后不再更新旧表单。
      debounceTimeout = setTimeout(() => {
        if (this.inputElement.isConnected) {
          this.validatePostalCode(this.inputElement.value);
        }
      }, 500);
    });

    // 点击查询按钮和按 Enter 共用 submit，始终阻止页面跳转。
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(debounceTimeout);
      this.validatePostalCode(this.inputElement.value);
    });
  }

  validatePostalCode(code) {
    code = code.trim();
    if (code.length < 5) code = "";

    const codes = getDeliveryPostalCodes();
    const isValid = !!code && !!codes?.has(code);

    if (!code) {
      this.clearResult();
    } else {
      // 数据不可用不等于邮编不在配送范围内。
      this.showResult(isValid, codes === null
        ? "Die Verfügbarkeit von Powerness Express kann derzeit nicht geprüft werden. Bitte versuchen Sie es später erneut."
        : "");
    }

    // 触发邮编验证结果事件
    document.dispatchEvent(
      new CustomEvent("postal-code:validated", {
        detail: {
          code: code,
          isValid: isValid,
        },
      })
    );

    return isValid;
  }

  showResult(isValid, message = "") {
    // Clear previous results
    this.clearResult();

    if (!this.resultElement) return;

    // Create result message
    const resultDiv = document.createElement("div");
    resultDiv.className = isValid ? "validation-success" : "validation-error";

    // Create icon element
    const iconSpan = document.createElement("span");
    iconSpan.className = "validation-icon";
    iconSpan.innerHTML = isValid
      ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#4CAF50"/><path d="M8 10L9.5 11.5L12.5 8.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#FF5252"/><path d="M7 7L13 13M13 7L7 13" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>';

    // Create message element
    const messageSpan = document.createElement("span");
    messageSpan.className = "validation-message";
    messageSpan.textContent = message || (isValid
      ? "Ihre Postleitzahl liegt im Liefergebiet von Powerness Express."
      : "Ihre Postleitzahl liegt nicht im Liefergebiet von Powerness Express. Bitte wählen Sie eine andere Postleitzahl oder den Standardversand.");

    resultDiv.appendChild(iconSpan);
    resultDiv.appendChild(messageSpan);
    this.resultElement.appendChild(resultDiv);

    // Show the result element
    this.resultElement.style.display = "block";
  }

  clearResult() {
    if (this.resultElement) {
      this.resultElement.innerHTML = "";
      this.resultElement.style.display = "none";
    }
  }

}

// 新旧模块逐个表单初始化；WeakSet 防止重复绑定，并允许旧 DOM 被回收。
const initializedPostalCodeForms = new WeakSet();
function initPostalCodeForms(root = document) {
  root.querySelectorAll(".distribution-tabs .postal-code-form, .popup-library-drawer-delivery .postal-code-form").forEach((form) => {
    if (initializedPostalCodeForms.has(form)) return;
    const input = form.querySelector(".postal-code-input");
    const result = form.parentElement.querySelector(".postal-code-result");
    if (!input || !result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");
    new PostalCodeValidator(input, result);
    initializedPostalCodeForms.add(form);
  });
}

// 所有表单共用邮编集合，JSON 节点更新后自动重建，不再使用测试邮编兜底。
let cachedPostalCodeSource;
let cachedDeliveryPostalCodes = null;
function getDeliveryPostalCodes() {
  const source = getPopupDeliveryData()?.postalCodes;
  if (source === cachedPostalCodeSource) return cachedDeliveryPostalCodes;
  cachedPostalCodeSource = source;
  cachedDeliveryPostalCodes = null;

  let values = source;
  if (source && !Array.isArray(source) && typeof source === "object") {
    const key = ["postal_codes", "codes", "zip_codes", "postcodes", "data"].find((key) => Array.isArray(source[key]));
    values = key ? source[key] : Object.values(source);
    if (!key && !values.length) return null;
  }
  if (Array.isArray(values)) {
    const codes = values
      .filter((value) => typeof value === "string" || typeof value === "number")
      .map((value) => String(value).trim())
      .filter((value) => /^\d{5}$/.test(value));
    if (!values.length || codes.length) cachedDeliveryPostalCodes = new Set(codes);
  }
  return cachedDeliveryPostalCodes;
}

class StorePickerModal {
  constructor(options = {}) {
    this.modalId = options.modalId || "store-picker-modal";
    this.triggerSelector = options.triggerSelector || ".pickup-location-button";
    this.closeSelector = options.closeSelector || ".store-picker-modal-close";
    this.overlaySelector =
      options.overlaySelector || ".store-picker-modal-overlay";

    this.modal = document.getElementById(this.modalId);
    this.triggers = document.querySelectorAll(this.triggerSelector);

    if (!this.modal || this.triggers.length === 0) {
      console.warn("Store picker modal elements not found");
      return;
    }

    this.closeButton = this.modal.querySelector(this.closeSelector);
    this.overlay = this.modal.querySelector(this.overlaySelector);

    this.init();
  }

  init() {
    this.setupTriggers();
    this.setupCloseEvents();
  }

  setupTriggers() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.openModal();
      });
    });
  }

  setupCloseEvents() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.closeModal());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.closeModal());
    }

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen()) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.modal.classList.add("active");
    document.body.style.overflow = "hidden"; // Prevent scrolling

    // Dispatch custom event
    this.modal.dispatchEvent(new CustomEvent("modal:opened"));
  }

  closeModal() {
    this.modal.classList.remove("active");
    document.body.style.overflow = ""; // Enable scrolling

    // Dispatch custom event
    this.modal.dispatchEvent(new CustomEvent("modal:closed"));
  }

  isOpen() {
    return this.modal.classList.contains("active");
  }
}

// 同一 JSON 节点只解析一次；section 重渲染替换节点后重新读取。
let cachedPopupDeliveryDataElement;
let cachedPopupDeliveryData;
let deliveryInfoModal;
let deliveryInfoTrigger;
let deliveryInfoOverflow;

function getPopupDeliveryData() {
  const element = document.querySelector("[data-popup-delivery-data]");
  if (!element) return null;

  if (element !== cachedPopupDeliveryDataElement) {
    cachedPopupDeliveryDataElement = element;
    try {
      cachedPopupDeliveryData = JSON.parse(element.textContent);
    } catch (error) {
      cachedPopupDeliveryData = null;
      console.error("Invalid popup delivery data:", error);
    }
  }
  return cachedPopupDeliveryData;
}

// 富文本渲染函数
function renderRichText(data) {
  if (!data || !data.children) return '';

  let html = '';

  data.children.forEach(child => {
    switch (child.type) {
      case 'paragraph':
        html += '<p style="margin-bottom: 12px;">';
        if (child.children) {
          child.children.forEach(textChild => {
            if (textChild.type === 'text') {
              if (textChild.bold) {
                html += `<strong>${textChild.value}</strong>`;
              } else {
                html += textChild.value;
              }
            }
          });
        }
        html += '</p>';
        break;

      case 'list':
        const listTag = child.listType === 'ordered' ? 'ol' : 'ul';
        html += `<${listTag} style="margin-bottom: 12px; padding-left: 20px;">`;
        if (child.children) {
          child.children.forEach(listItem => {
            if (listItem.type === 'list-item') {
              html += '<li style="margin-bottom: 8px;">';
              if (listItem.children) {
                listItem.children.forEach(textChild => {
                  if (textChild.type === 'text') {
                    if (textChild.bold) {
                      html += `<strong>${textChild.value}</strong>`;
                    } else {
                      html += textChild.value;
                    }
                  }
                });
              }
              html += '</li>';
            }
          });
        }
        html += `</${listTag}>`;
        break;
    }
  });

  return html;
}

// 三种配送说明共用一个弹窗；普通配送沿用原来的 title / cancel_button_text 字段。
const deliveryInfoTypes = [
  {
    selector: ".store-picker-modal-open",
    contentKey: "storePickerContent",
    titleKey: "store_picker_modal_title",
    buttonKey: "store_picker_modal_close_button_text",
    fallbackTitle: "Wichtige Hinweise zur Selbstabholung",
    className: "store-picker-info-modal",
  },
  {
    selector: ".special-offer-modal-open",
    contentKey: "specialOfferContent",
    titleKey: "special_offer_modal_title",
    buttonKey: "special_offer_modal_close_button_text",
    fallbackTitle: "Powerness Express Informationen",
    className: "special-offer-info-modal",
  },
  {
    selector: ".normal-delivery-button, .normal-delivery-button-mobile",
    contentKey: "normalDeliveryContent",
    titleKey: "title",
    buttonKey: "cancel_button_text",
    fallbackTitle: "Delivery time limit",
    className: "normal-delivery-info-modal",
  },
];
const deliveryInfoSelector = deliveryInfoTypes.map((type) => type.selector).join(", ");

function openDeliveryInfoModal(trigger) {
  const type = deliveryInfoTypes.find((type) => trigger.matches(type.selector));
  if (!type) return;
  const data = getPopupDeliveryData();
  const richText = data?.[type.contentKey];
  // 关闭动画完成前也不重新打开，避免旧定时器隐藏刚打开的弹窗。
  if (!richText || deliveryInfoModal?.overlayElement.style.display === "flex") return;

  const settings = data.settings || {};
  const title = settings[type.titleKey] || type.fallbackTitle;
  const buttonText = settings[type.buttonKey] || "cancel";
  const content = `
    <div style="text-align: left; padding: 20px 0;">
      <div style="color: #666; line-height: 1.6;">
        ${renderRichText(richText)}
      </div>
    </div>
  `;

  if (!deliveryInfoModal) {
    deliveryInfoModal = new Modal({
      title,
      content,
      buttons: [{ text: buttonText, type: "cancel" }],
      onOpen: () => {
        if (typeof trapFocus === "function") {
          trapFocus(deliveryInfoModal.modalElement);
        }
      },
      onClose: () => {
        document.body.style.overflow = deliveryInfoOverflow;
        if (typeof removeTrapFocus === "function") {
          removeTrapFocus(deliveryInfoTrigger?.isConnected ? deliveryInfoTrigger : null);
        }
      },
    });
    // 当前信息弹窗的容器样式由 CSS 管理，显示/关闭时仍由 Modal 控制 transform。
    deliveryInfoModal.modalElement.classList.add("delivery-info-modal");
    deliveryInfoModal.modalElement.style.cssText = "";
    deliveryInfoModal.modalElement.setAttribute("data-trap", "");
    deliveryInfoModal.modalElement.setAttribute("role", "dialog");
    deliveryInfoModal.modalElement.setAttribute("aria-modal", "true");
    deliveryInfoModal.modalElement.tabIndex = -1;
  }

  deliveryInfoTrigger = trigger;
  deliveryInfoOverflow = document.body.style.overflow;
  deliveryInfoTypes.forEach((item) => {
    deliveryInfoModal.modalElement.classList.toggle(item.className, item === type);
  });
  deliveryInfoModal.updateTitle(title);
  deliveryInfoModal.updateContent(content);
  deliveryInfoModal.modalElement.setAttribute("aria-label", title);
  deliveryInfoModal.modalElement.querySelector(".modal-button").textContent = buttonText;
  deliveryInfoModal.show();
}

// Initialize when DOM is loaded
document.addEventListener("shopify:section:load", (event) => initPostalCodeForms(event.target));
document.addEventListener("DOMContentLoaded", function () {
  initPostalCodeForms();
  // 捕获阶段先处理链接：抽屉会阻止冒泡，旧配送卡片也不应因点击说明而切换。
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest?.(deliveryInfoSelector);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openDeliveryInfoModal(trigger);
  }, true);

  // Initialize all distribution tabs
  const distributionTabsContainers =
    document.querySelectorAll(".distribution-tabs");
  distributionTabsContainers.forEach((container) => {
    new DistributionTabs(container);
  });
  const distributionTabsDesktopContainers = document.querySelectorAll(
    ".distribution-tabs-desktop"
  );
  distributionTabsDesktopContainers.forEach((container) => {
    new DistributionTabs(container);
  });
  // Initialize store picker modal
  new StorePickerModal();

  // 示例：监听变体metafields变化，根据变体metafields更新分发选项
  document.addEventListener("variant:metafields:changed", function (event) {
    const { variantId, metafields, variant } = event.detail;

    // 示例：检查变体是否有特殊的配送方式metafield
    if (metafields.shipping_method && metafields.shipping_method.value) {
      console.log("变体特殊配送方式:", metafields.shipping_method.value);

      // 根据变体metafields更新配送选项
      const distributionTabs = document.querySelector(".distribution-tabs");
      if (distributionTabs) {
        // 你可以在这里添加逻辑来根据变体metafields调整配送选项
        // 例如：某些变体只支持特定的配送方式
      }
    }

    // 示例：检查变体是否有库存位置metafield
    if (metafields.warehouse_location && metafields.warehouse_location.value) {
      console.log("变体库存位置:", metafields.warehouse_location.value);

      // 根据库存位置更新自提点选项
      const storePickerModal = document.getElementById("store-picker-modal");
      if (storePickerModal) {
        // 你可以在这里添加逻辑来根据变体的库存位置过滤自提点
      }
    }
  });
});
